import { loadable } from '@shared/core/loadableFromNamedExport';

// Lazy route entry so the head wrapper + GuestSiteHeadCsr aren't pulled into the eager guest shell.
// Mirrors LazyGuestSite: the SSR-rendered head still resolves because the guest SSR pipeline collects
// this route chunk; the form body (LazyRegistrationGuest) stays in its own chunk via NoSsr.
export const LazyRegistrationGuestWithHead = loadable(
  () => import(/* webpackChunkName: "content/registration/guest-head" */ './RegistrationGuestWithHead'),
  'RegistrationGuestWithHead',
);
